import { languages } from "countries-list";

import { LanguageCode, LanguageOption } from "@/types";

export const getLanguageOption = (languageCode: LanguageCode): LanguageOption => {
  return {
    ...languages[languageCode],
    iso2: languageCode
  };
};
